// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';
import { ProductInvoiceModel } from '../../types/Products';

setGenerator(uuidv4);

export default class InvoicingProducts extends Model {
    static table = 'invoicing_products';

    static associations = {
        invoices: { type: 'belongs_to', key: 'invoice_id' },
    };

    @field('name') name;
    @field('price') price;
    @field('available') available;
    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;
}

export type InvoicingProductSimple = {
    id: string;
    name: string;
    price: string;
    available: boolean;
    organisationId: string;
    userId: string;
    createdAt: string;
    updatedAt: string;
};

export const simplifyInvoicingProduct = (
    invoicingProduct: ProductInvoiceModel,
): InvoicingProductSimple => {
    return {
        id: invoicingProduct.id,
        name: invoicingProduct.name,
        price: invoicingProduct.price,
        available: invoicingProduct.available,
        organisationId: invoicingProduct.organisationId,
        userId: invoicingProduct.userId,
        createdAt: invoicingProduct.createdAt.toISOString(),
        updatedAt: invoicingProduct.updatedAt.toISOString(),
    };
};
